import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ServicesOverview from "./components/ServicesOverview";
import WhyChooseUs from "./components/WhyChooseUs";
import Testimonials from "./components/Testimonials";
import CTASection from "./components/CTASection";
import PostcodeChecker from "../../components/feature/PostcodeChecker";
import ContactSection from "./components/ContactSection";
import SEOHead from "../../components/feature/SEOHead";
import JsonLd from "../../components/feature/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://mightycleaningservices.co.uk";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": `${siteUrl}/#webpage`,
  "url": `${siteUrl}/`,
  "name": "Window Cleaning Northfleet & Gravesend | Gutter Clearance Kent | Mighty Cleaning Services Ltd",
  "description":
    "Mighty Cleaning Services Ltd — professional window cleaning, gutter clearance, fascia & soffit cleaning, pressure washing and solar panel cleaning in Northfleet, Gravesend & Kent. Rated 4.9★ on Google. Fully insured.",
  "inLanguage": "en-GB",
  "isPartOf": {
    "@type": "WebSite",
    "@id": `${siteUrl}/#website`,
    "name": "Mighty Cleaning Services Ltd",
    "url": siteUrl,
  },
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": `${siteUrl}/`,
      },
    ],
  },
  "provider": {
    "@type": "LocalBusiness",
    "name": "Mighty Cleaning Services Ltd",
    "telephone": "02084322244",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Suite 2007, Fleet House, Springhead Enterprise Park, Springhead Rd",
      "addressLocality": "Northfleet",
      "addressRegion": "Kent",
      "postalCode": "DA11 9HJ",
      "addressCountry": "GB",
    },
  },
};

export default function HomePage() {
  return (
    <div className="font-body">
      <SEOHead
        title="Window Cleaning Northfleet & Gravesend | Gutter Clearance Kent | Mighty Cleaning Services Ltd"
        description="Mighty Cleaning Services Ltd — professional window cleaning, gutter clearance, fascia & soffit cleaning, pressure washing and solar panel cleaning in Northfleet, Gravesend & Kent. Rated 4.9★ on Google. Fully insured. Call 0208 43 222 44 for a free quote."
        keywords="window cleaning Northfleet, window cleaners Gravesend, gutter clearance Northfleet, gutter cleaning Gravesend, fascia soffit cleaning Kent, pressure washing Gravesend, solar panel cleaning Kent"
        canonical={`${siteUrl}/`}
      />
      <JsonLd id="home-webpage" data={homeJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesOverview />
        <WhyChooseUs />
        <Testimonials />
        <CTASection />
        <PostcodeChecker />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
